<template>
  <div style="min-height: 240px;">
    <div class="chart-title">Success rate</div>
    <div v-if="!hideSettings" class="settings-button">
        <miniSettings :position="position" :minis="minis" />
      </div>
    <apexchart class="mb-6"   height="240" type="radialBar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import miniSettings from "./miniSettings";
export default {
  name:"MiniGauge",
  components: {miniSettings},
  props: ["data", "position", "minis", "hideSettings"],
  data() {
    return {
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      chartOptions: {
        colors: ["#20E647"],
        fill: {
          background: "#293450",
          colors: ["#79C04D"],
          opacity: 1,
          type: "solid"
        },
        chart: {
          foreColor: "#373d3f",
          fontFamily: "Roboto Condensed, sans-serif",
          id: "vuechart-example"
        },
        labels: ["success rate"],
        plotOptions: {
          radialBar: {
            track: {
              background: "#404855",
            },

            //hollow: {
            //  margin: 15,
            //  size: "60%"
            //},
            background: "#79C04D",
            dataLabels: {
              showOn: "always",
              name: {
                offsetY: 20,
                show: true,
                color: "#79C04D",
                fontSize: "13px"
              },
              value: {
                offsetY: -15,
                color: "#79C04D",
                fontSize: "35px",
                show: true
              }
            }
          }
        }
      },
      series: [this.data.toFixed(1)]
    };
  },
  watch: {
    data(val) {
      this.series = [val.toFixed(1)]
    }
  },
};
</script>

<style>
</style>